import { render, staticRenderFns } from "./submit-form.vue?vue&type=template&id=6fa72521&scoped=true&"
import script from "./submit-form.vue?vue&type=script&lang=js&"
export * from "./submit-form.vue?vue&type=script&lang=js&"
import style0 from "./submit-form.vue?vue&type=style&index=0&id=6fa72521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa72521",
  null
  
)

export default component.exports